
  (function () {
    'use strict';

    const sectionInstances = new WeakMap();
    const activeSections = new Set();

    let globalResizeHandler = null;
    let resizeHandlerAttached = false;

    class FAQSection {
      constructor(rootElement) {
        this.root = rootElement;
        this.clickHandler = null;
        this.mutationObserver = null;
        this.initialized = false;
      }

      init() {
        if (this.initialized) return;

        this.setupClickHandler();
        this.setupMutationObserver();
        this.updateResponsiveFontSizes();
        this.initialized = true;
      }

      setupClickHandler() {
        if (this.clickHandler) return;

        this.clickHandler = (e) => {
          const questionEl = e.target.closest('.store-faq-question');
          if (!questionEl || !this.root.contains(questionEl)) return;

          e.preventDefault();
          e.stopPropagation();

          const item = questionEl.closest('.store-faq-item');
          if (!item) return;

          const columnContainer = questionEl.closest('.store-faq-items-container');
          if (!columnContainer) return;

          const scopeIsAccordion = columnContainer.getAttribute('data-accordion') === 'true';

          if (scopeIsAccordion && !item.classList.contains('active')) {
            const activeItems = columnContainer.querySelectorAll('.store-faq-item.active');
            activeItems.forEach((other) => {
              if (other !== item && !other.classList.contains('mobile-only-item')) {
                other.classList.remove('active');
              }
            });
          }

          item.classList.toggle('active');
        };

        this.root.addEventListener('click', this.clickHandler, true);
      }

      setupMutationObserver() {
        if (this.mutationObserver) return;

        this.mutationObserver = new MutationObserver((mutations) => {
          for (const m of mutations) {
            if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
              this.init();
              break;
            }
          }
        });

        this.mutationObserver.observe(this.root, { childList: true, subtree: true });
      }

      updateResponsiveFontSizes() {
        /* Mobile font sizes now handled by CSS media query — no JS needed */
      }

      cleanup() {
        if (this.clickHandler) {
          this.root.removeEventListener('click', this.clickHandler, true);
          this.clickHandler = null;
        }

        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
          this.mutationObserver = null;
        }

        this.initialized = false;
      }
    }

    function getOrCreateFAQSection(sectionId) {
      const root = document.querySelector(`#store-faq-${sectionId}`);
      if (!root) return null;
      let instance = sectionInstances.get(root);

      if (!instance) {
        instance = new FAQSection(root);
        sectionInstances.set(root, instance);
        activeSections.add(instance);
      }

      return instance;
    }

    // Start FAQ section
    function initFAQ() {
      const instance = getOrCreateFAQSection('template--30445709951324__store_faq_EJ6wGr');
      if (!instance) {
        setTimeout(initFAQ, 100);
        return;
      }

      instance.init();
    }

    function cleanupFAQ() {
      const root = document.querySelector('#store-faq-template--30445709951324__store_faq_EJ6wGr');
      if (!root) return;

      const instance = sectionInstances.get(root);
      if (instance) {
        instance.cleanup();
        activeSections.delete(instance);
        sectionInstances.delete(root);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFAQ);
    } else {
      initFAQ();
    }

    // Shopify JS hooks
    document.addEventListener('shopify:section:load', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--30445709951324__store_faq_EJ6wGr') return;
      initFAQ();
    });

    document.addEventListener('shopify:section:select', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--30445709951324__store_faq_EJ6wGr') return;
      initFAQ();
    });

    document.addEventListener('shopify:section:reorder', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--30445709951324__store_faq_EJ6wGr') return;
      initFAQ();
    });

    document.addEventListener('shopify:section:unload', function (evt) {
      if (!evt.detail || evt.detail.sectionId !== 'template--30445709951324__store_faq_EJ6wGr') return;
      cleanupFAQ();
    });
    // Redundancy fallback
    window.addEventListener('load', initFAQ);
  })();
